/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState, useEffect } from "react";
import { routeDashboard, routeLogin, routeRoot } from "../../settings/routeConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { useLayout } from "./LayoutContext";

import getParamsEnv from '../../utils/getParamsEnv'
import { isErrorForm, isNullOrEmpty, tiempoCierreSession } from '../../utils/Utils'

export const tokenName = "Hcorz-dashboard-token";
export const tokenRefreshName = "Hcorz-dashboard-tokenRefresh";
import axios from "axios"

const getLoginForm = () => ({
  username: { value: "", error: false },
  password: { value: "", error: false },
});

const getConfiguracionDefault = () => ({
  tituloNavegador: "Hcorz",
  tituloDependencia: "PLATAFORMA DE Hcorz",
  metaDescription: "Plataforma de Hcorz",
  colorPrimario: "#095fb4", // #FD8204
  colorSecundario: "#0A5DA6", // #16216A
  contrastePrimario: "#FFFFFF",
  contrasteSecundario: "#FFFFFF",
  urlFuente: "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap",
  nombreFuente: "Roboto",
  rutaImagenFondo: "",
  rutaImagenLogo: "",
  rutaImagenPortal: "",
});

const { API_URL_BASE, DASHBOARD } = getParamsEnv();

const getCambiarPasswordForm = () => ({
  username: { value: "", error: false },
});

export const SesionContext = createContext();
export const SesionProvider = (props) => {

  const { API_URL_BASE, DASHBOARD } = getParamsEnv();

  const { handleOpenAlert, handleOpenLoader, handleCloseLoader } = useLayout();

  const location = useLocation();
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState(null);
  const [usuarioData, setUsuarioData] = useState([]);
  const [tokenSeguridad, setTokenSeguridad] = useState("");
  const [tokenRefresh, setTokenRefresh] = useState("");
  const [configuracion, setConfiguracion] = useState(getConfiguracionDefault());

  const [usuarioEnSesion, setUsuarioEnSesion] = useState(false);
  const [loginForm, setLoginForm] = useState(getLoginForm());
  const [previousRoute, setPreviousRoute] = useState("");

  const events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];
  let timer;

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      events.forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      handleClickCerrarSesion();
    }, tiempoCierreSession);
  };

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    handleClickCerrarSesion();
    const handleOnLoadToken = async () => {
      const currentToken = localStorage.getItem(tokenName);
      const currentTokenRefresh = localStorage.getItem(tokenRefreshName);

      if (isNullOrEmpty(currentToken)) {
        handleClickCerrarSesion();
        return;
      }

      const entRefreshToken = {
        sToken: currentToken,
        sRefreshToken: currentTokenRefresh,
      };

      try {
        handleOpenLoader("");
        const loginResponse = "ok";
        // const loginResponse = await fetch(apiLoginRefresh, {
        //   method: "GET",
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: "Bearer " + currentToken,
        //   },
        //   body: JSON.stringify(entRefreshToken),
        // });

        handleCloseLoader();

        if (!loginResponse === "ok") {
          handleClickCerrarSesion();
          return;
        }

        // const response = await loginResponse.json();

        // if (response.hasError) {
        //   handleClickCerrarSesion();
        //   return;
        // }

        // saveLoginResponse(response);
      } catch (error) {
        handleCloseLoader();
        handleClickCerrarSesion();
      }
    };

    handleOnLoadToken();
    events.forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });

    return () => {
      resetTimer();
      events.forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
    };
  }, []);

  const saveLoginResponse = (loginResponse, menus) => {
    localStorage.setItem(tokenName, loginResponse.token);
    localStorage.setItem(tokenRefreshName, loginResponse.token);

    const datauser = {
      Usuario: loginResponse.loginUser?.roleid ? loginResponse.loginUser?.roleid : "",
      Nombre: loginResponse.loginUser?.userName ? loginResponse.loginUser?.userName : "",
      menus: menus,
      role: loginResponse.loginUser.Role?.rolename || loginResponse.loginUser?.roleid,
      image: null
    }

    setUsuarioData(datauser);
    setUsuario(loginResponse.loginUser?.roleid);
    setTokenSeguridad(loginResponse.token);
    setTokenRefresh(loginResponse.token);
    setUsuarioEnSesion(true);
    setPreviousRoute("/dashboard");

    if (previousRoute === routeLogin) {
      navigate(routeLogin, { replace: true });
      return;
    }

    if (!isNullOrEmpty(previousRoute)) {
      navigate(previousRoute, { replace: true });
    }
    else {
      navigate("/", { replace: true });
    }
  };

  const handleChangeLoginForm = (e) => {
    setLoginForm({
      ...loginForm,
      [e.target.name]: {
        value: e.target.value,
        error: false,
      },
    });
  };

  const handleSubmitLoginForm = async (e) => {
    e.preventDefault();
    await setPreviousRoute(routeDashboard);

    const { password, username } = loginForm;

    const form = {
      ...loginForm,
      password: { ...password, error: password.value === "" },
      username: { ...username, error: username.value === "" },
    };

    setLoginForm(form);
    if (isErrorForm(form)) {
      return;
    }

    const loginRequest = {
      userName: username.value,
      password: password.value,
    };

    try {
      const loginResponse = await axios.post(`${API_URL_BASE}login`, loginRequest);
      const { token, loginUser: user } = loginResponse.data;

      if (!loginResponse.statusText == 'OK') {
        handleOpenAlert("error en credenciales de acceso");
        return;
      }

      localStorage.setItem("token", token);

      const menuRes = await axios.get(`${API_URL_BASE}menu/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!menuRes.statusText === "OK") {
        handleOpenAlert("error al obtener menus asignados");
        return;
      }



      setLoginForm(getLoginForm());
      saveLoginResponse(loginResponse.data, menuRes.data);

      navigate(routeDashboard);
    } catch (error) {
      handleOpenAlert("Ocurrió un error inesperado al intentar validar las credenciales" + error, "error");
    }
  };

  const handleClickCerrarSesion = () => {
    setTokenSeguridad("");
    setTokenRefresh("");
    setConfiguracion(getConfiguracionDefault());
    setUsuarioEnSesion(false);
    setLoginForm(getLoginForm());
    localStorage.removeItem(tokenName);
    localStorage.removeItem(tokenRefreshName);
    setPreviousRoute(location.pathname);
    navigate("/");
    setUsuario(null);
  };

  const handleClickRegresarLogin = async () => {
    navigate(routeLogin);
  };

  const handleClicValidarActivarSesion = async () => {
    const token = localStorage.getItem(tokenName);
    const tokenRefresh = localStorage.getItem(tokenRefreshName);

    if (isNullOrEmpty(token) || isNullOrEmpty(tokenRefresh)) {
      setUsuarioEnSesion(false);
      return;
    }

    const entRefreshToken = {
      sToken: token,
      sRefreshToken: tokenRefresh,
    };

    try {
      handleOpenLoader("");
      // const loginResponse = await fetch(apiLoginRefresh, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: "Bearer " + token,
      //   },
      //   body: JSON.stringify(entRefreshToken),
      // });

      handleCloseLoader();

      // if (!loginResponse.ok) {
      //   handleClickCerrarSesion();
      //   return;
      // }

      // const response = await loginResponse.json();

      // if (response.hasError) {
      //   handleClickCerrarSesion();
      //   return;
      // }

      // saveLoginResponse(response);
    } catch (error) {
      handleCloseLoader();
      handleClickCerrarSesion();
    }
  };

  return (
    <SesionContext.Provider
      value={{
        usuario, usuarioData,
        tokenSeguridad,
        tokenRefresh,
        usuarioEnSesion,
        configuracion,
        loginForm,
        previousRoute,
        handleChangeLoginForm,
        handleSubmitLoginForm,
        handleClickCerrarSesion,
        handleClickRegresarLogin,
        handleClicValidarActivarSesion,
      }}
    >
      {props.children}
    </SesionContext.Provider>
  );
};

export const useSesion = () => useContext(SesionContext);